/* Shared purchase presentation for GirlyGlam's product templates. */
(() => {
  if (document.documentElement.dataset.ggPurchaseUiReady) return;
  document.documentElement.dataset.ggPurchaseUiReady = 'true';
  const markers = () => document.querySelectorAll('[data-gg-purchase-ui]');
  const sectionFor = form => form.closest('[id^="MainProduct-"]');

  function init() {
    markers().forEach(marker => {
      const section = marker.closest('[id^="MainProduct-"]');
      const pending = section?.querySelector('.select-options-button');
      if (pending) {
        pending.setAttribute('role', 'button');
        pending.setAttribute('aria-disabled', 'true');
      }
    });
  }

  async function refreshShipping(event) {
    if (!markers().length) return;
    try {
      const cart = event?.cartData?.total_price !== undefined
        ? event.cartData
        : await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(response => response.json());
      markers().forEach(marker => {
        const remaining = Math.max(5000 - cart.total_price, 0);
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: marker.dataset.currency || 'USD',
          minimumFractionDigits: 0, maximumFractionDigits: 2,
        }).format(remaining / 100);
        marker.querySelector('p span').textContent = remaining
          ? 'Spend ' + amount + ' more for free shipping'
          : "You've unlocked free shipping";
        marker.querySelector('progress').value = Math.min(cart.total_price, 5000);
      });
    } catch (_) { /* Preserve the server-rendered message if the cart cannot be read. */ }
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    const section = sectionFor(form);
    if (!section?.querySelector('[data-gg-purchase-ui]')) return;
    const button = form.querySelector('[name="add"]');
    if (button?.disabled || button?.getAttribute('aria-disabled') === 'true'
      || section.querySelector('select-option-js.active') || !form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function start() {
    init();
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshShipping);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', init);
})();
